import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Table,
  Input,
  Tag,
  Button as AntdButton,
  ConfigProvider,
  Avatar,
  Space,
  Modal,
} from "antd";
import { updateOrderCo } from "../../datasource/OrderDatasourc";
import dayjs from "dayjs";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import image from "../../resource/image";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import { numberFormatter } from "../../utility/Formatter";
import Select from "../../components/Select/Select";
import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { CardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Button from "../../components/Button/Button";
import { onInputNumberKeyPress } from "../../utility/validator";
import { useMessageContext } from "../../context/MessageProvider";

export const EditCoOrderDetail = () => {
  const { messageApi } = useMessageContext();
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const navigate = useNavigate();
  const { pathname } = window.location;
  const location = useLocation();
  const pathSplit = pathname.split("/") as Array<string>;
  const orderId = pathSplit[3];
  const [form] = Form.useForm();
  const _watchCoList = Form.useWatch(["products"], form);
  const dataCoType = location.state?.coData;
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalCheckDiscount, setModalCheckDiscount] = useState(false);
  const [isValidate, setIsValidate] = useState(false);

  const fetchCoList = async () => {
    const co = location.state?.coData;

    const mapProduct = co.products.map((product: any) => {
      const calLine = product.lines.map((line: any) => ({
        ...line,
        saleUOMTH: product.saleUOMTH,
        calDiscount:
          line.discountMode === "PCT_PER_UNIT"
            ? product.unitPrice * line.quantity * (line.discountValue / 100)
            : line.quantity * line.discountValue,
      }));
      return {
        ...product,
        lines: calLine,
        coId: co.coId,
        calTotalDiscount: product.totalDiscount,
        isFullDiscount:
          calLine.reduce((acc: number, line: any) => Number(acc) + Number(line.calDiscount), 0) >
          product.totalDiscount,
      };
    });

    const mapData = {
      coId: co.coId,
      code: co.code,
      name: co.name,
      type: co.type,
      creditMemoType: co.creditMemoType,
      startDate: dayjs(co.startDate).format("DD/MM/YYYY"),
      endDate: dayjs(co.endDate).format("DD/MM/YYYY"),
      quotaAmount: co.quotaAmount,
      quotaUsed: co.quotaUsed,
      quotaRemaining: co.quotaRemaining,
      usedThisOrder: co.usedThisOrder,
      products: mapProduct,
    };
    setModalCheckDiscount(mapData.products.some((prod: any) => prod.isFullDiscount));
    form.setFieldsValue(mapData);
  };

  useEffect(() => {
    fetchCoList();
  }, [orderId, form]);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title='แก้ไขรายการส่วนลด CO'
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text: "รายละเอียดคำสั่งซื้อ",
                path: -1,
              },
              {
                text: "แก้ไขรายการส่วนลด",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
    );
  };
  const DataCoDetail = () => {
    return (
      <div
        style={{
          borderLeft: `4px solid ${dataCoType?.creditMemoType?.color}`,
          paddingLeft: 8,
        }}
      >
        <Row justify='start' gutter={8} align='middle'>
          <Col>
            <Text level={3} fontWeight={600}>
              {dataCoType?.name}
            </Text>
          </Col>
          <Col>
            <Tag style={{ border: "none", borderRadius: 15, backgroundColor: "#EFF2F9" }}>
              <Text level={6}>{dataCoType?.products?.length || 0} รายการ</Text>
            </Tag>
          </Col>
        </Row>
        <Row>
          <Text level={6} color='Text3'>
            {dayjs(dataCoType?.startDate).format("DD/MM/YYYY")} -{" "}
            {dayjs(dataCoType?.endDate).format("DD/MM/YYYY")} • ใช้ไป(คำสั่งซื้อนี้){" "}
            <Text color={dataCoType?.usedThisOrder > 0 ? "error" : "Text3"} level={6}>
              {dataCoType?.usedThisOrder > 0
                ? `-${numberFormatter(dataCoType?.usedThisOrder || 0)}`
                : 0}
            </Text>
          </Text>
        </Row>
      </div>
    );
  };
  const checkQtyLine = (value: number, index: number) => {
    const calQty = form
      .getFieldsValue(true)
      ?.products?.[
        index
      ]?.lines?.reduce((acc: number, line: any) => Number(acc) + (Number(line.quantity) || 0), 0);

    if (calQty > value) {
      return { text: "เกิน", color: "error", value: calQty - value };
    } else if (calQty < value) {
      return { text: "ขาด", color: "warning", value: (calQty - value) * -1 };
    }
    return { text: "ครบ", color: "success" };
  };
  const checkQtyTotal = (value: number, index: number) => {
    const masterQty = dataCoType?.products?.[index]?.orderQuantity;

    if (value > masterQty) {
      return { text: "เกิน", color: "error", value: value - masterQty };
    } else if (value < masterQty) {
      return { text: "ขาด", color: "warning", value: (value - masterQty) * -1 };
    }
    return { text: "ครบ", color: "success" };
  };
  const checkQtyGrandTotal = () => {
    const masterUsed = dataCoType?.usedThisOrder;
    const totalUse = form
      .getFieldsValue(true)
      ?.products?.reduce(
        (acc: number, product: any) => Number(acc) + (Number(product.calTotalDiscount) || 0),
        0,
      );

    if (totalUse > masterUsed) {
      setIsValidate(true);
      return { text: "เกิน", color: "error", value: totalUse - masterUsed };
    } else if (totalUse < masterUsed) {
      setIsValidate(true);
      return { text: "ขาด", color: "warning", value: (totalUse - masterUsed) * -1 };
    }
    setIsValidate(false);
    return { text: "ครบ", color: "success" };
  };
  const calTotalDiscountInProd = (indexProd: number) => {
    const dataForm = form.getFieldsValue(true);
    const dataProd = form.getFieldsValue(true).products[indexProd];
    const unitPrice = dataCoType.products[indexProd].unitPrice;

    const calTotalDiscount = dataProd.lines.reduce((acc: number, line: any) => {
      let cal = 0;
      if (line.discountMode === "PCT_PER_UNIT") {
        cal = acc + (line.quantity || 0) * ((unitPrice * line.discountValue) / 100);
      } else {
        cal = acc + (line.quantity || 0) * (line.discountValue || 0);
      }
      return cal;
      dataForm.products.length > 1
        ? cal
        : cal > dataProd.totalDiscount
          ? dataProd.totalDiscount
          : cal;
    }, 0);
    form.setFieldValue(["products", indexProd, "calTotalDiscount"], calTotalDiscount);
    calDiscountInLine();
  };
  const calDiscountInLine = () => {
    const dataForm = form.getFieldsValue(true);
    const dataProduct = form.getFieldsValue(true).products;
    const mapData = dataProduct.map((prod: any) => {
      const mapLines = prod.lines.map((line: any) => {
        let calDiscount = 0;
        if (line.discountMode === "PCT_PER_UNIT") {
          calDiscount = (line.quantity || 0) * ((prod.unitPrice * line.discountValue) / 100);
        } else {
          calDiscount = (line.quantity || 0) * (line.discountValue || 0);
        }
        return {
          ...line,
          calDiscount,
        };
      });
      return {
        ...prod,
        lines: mapLines,
      };
    });
    form.setFieldValue("products", mapData);
    const afterCal = form.getFieldsValue(true).products;
    const mapIsFullDiscount = afterCal.map((prod: any) => ({
      ...prod,
      isFullDiscount:
        afterCal.length < 1
          ? afterCal.reduce(
              (acc: number, value: any) => Number(acc) + Number(value.calTotalDiscount),
              0,
            ) > dataForm.usedThisOrder
          : false,
    }));
    form.setFieldValue("products", mapIsFullDiscount);
  };

  const columns = [
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow align='center'>
              <div style={{ marginRight: 16 }}>
                <Avatar
                  src={
                    row?.productImage === "No" ||
                    row?.productImage === "" ||
                    row?.productImage === null
                      ? image.product_no_image
                      : row?.productImage
                  }
                  size={50}
                  shape='square'
                  onError={() => false}
                />
              </div>
              <FlexCol>
                <div style={{ height: 25, textOverflow: "ellipsis" }}>
                  <Text level={5}>{row?.productName || "-"}</Text>
                </div>
                {row?.commonName && (
                  <div style={{ height: 25, textOverflow: "ellipsis" }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      {row?.commonName || "-"}
                    </Text>
                  </div>
                )}
                <Text level={6} style={{ color: color.Grey }}>
                  Pack Size : {row?.packSize || "-"}
                </Text>
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ราคาขาย",
      dataIndex: "unitPrice",
      key: "unitPrice",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value)}</Text>
              <Row>
                <Text level={6} style={{ color: color.Grey }}>
                  บาท/{row?.saleUOMTH || "-"}
                </Text>
              </Row>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "จำนวนในออเดอร์นี้",
      dataIndex: "orderQuantity",
      key: "orderQuantity",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Row style={{ alignItems: "center" }} gutter={16}>
                <FlexCol>
                  <Text>{numberFormatter(value)}</Text>
                  <Text color='Text3' level={6}>
                    /{numberFormatter(value)} {row?.saleUOMTH || ""}
                  </Text>
                </FlexCol>
                <Col>
                  <Tag
                    color={checkQtyLine(value, index).color}
                    style={{ border: "none", borderRadius: 8 }}
                  >
                    <Text
                      style={{ color: color[checkQtyLine(value, index).color] }}
                      level={6}
                      fontWeight={400}
                    >
                      {checkQtyLine(value, index).text}{" "}
                      {(checkQtyLine(value, index).value &&
                        `${numberFormatter(checkQtyLine(value, index).value || 0)} ${row?.saleUOMTH || ""}`) ||
                        ""}
                    </Text>
                  </Tag>
                </Col>
              </Row>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รวมส่วนลดรายการนี้",
      dataIndex: "calTotalDiscount",
      key: "calTotalDiscount",
      render: (value: any, row: any, index: number) => {
        const keyName = ["products", index, "calTotalDiscount"];
        const keyFullDiscount = ["products", index, "isFullDiscount"];
        return {
          children: (
            <FlexCol>
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => (
                  <Text fontWeight={600}>{numberFormatter(getFieldValue(keyName))}</Text>
                )}
              </Form.Item>
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const isFullDiscountValue = getFieldValue(keyFullDiscount);
                  return isFullDiscountValue ? (
                    <Text color='warning' level={6}>
                      ส่วนลดถูกจำกัดตามยอดคงเหลือ
                    </Text>
                  ) : null;
                }}
              </Form.Item>
            </FlexCol>
          ),
        };
      },
    },
  ];

  const addNewLine = (row: any) => {
    const formData = form.getFieldsValue(true).products;
    const newMap = formData.map((prod: any) => {
      const find = prod.productId === row.productId;
      if (find) {
        const newLines = [
          ...(prod.lines || []),
          {
            quantity: undefined,
            discountValue: undefined,
            discountMode: "BAHT_PER_UNIT",
            lineNo: prod.lines.length + 1,
            saleUOMTH: prod.saleUOMTH,
          },
        ];
        return {
          ...prod,
          lines: newLines,
        };
      } else {
        return prod;
      }
    });
    form.setFieldsValue({ products: newMap });
  };

  const onDeleteLine = (row: any, lineIndex: number, indexProd: number) => {
    const formData = form.getFieldsValue(true).products;
    const newMap = formData.map((prod: any) => {
      if (prod.productId === row.productId) {
        const newLines = prod.lines.filter((_: any, index: number) => index !== lineIndex);
        return {
          ...prod,
          calTotalDiscount: newLines.reduce((acc: number, line: any) => acc + line.coDiscount, 0),
          lines: newLines,
        };
      }
      return prod;
    });
    form.setFieldsValue({ products: newMap });
    calTotalDiscountInProd(indexProd);
  };

  const validateTotalQty = (indexProd: number, record: any) => {
    const totalQty = form
      ?.getFieldValue(["products", indexProd, "lines"])
      .reduce((acc: number, line: any) => Number(acc) + (Number(line.quantity) || 0), 0);
    return totalQty > record?.orderQuantity;
  };

  const onSubmit = async () => {
    try {
      await form.validateFields();
      const formData = form.getFieldsValue(true);
      const payload = {
        remark: formData.remark,
        cos: [
          {
            coId: formData.coId,
            products: formData.products.map((prod: any) => ({
              orderProductId: prod.orderProductId,
              lines: prod.lines.map((line: any) => ({
                quantity: Number(line.quantity),
                discountValue: Number(line.discountValue),
                discountMode: line.discountMode,
              })),
            })),
          },
        ],
      };
      await updateOrderCo({
        params: payload,
        orderId,
        updateBy: userProfile.firstname + " " + userProfile.lastname,
      }).then((res) => {
        if (res.success) {
          messageApi.success("บันทึกสำเร็จ");
          navigate(-1);
        }
      });
    } catch (e) {
      console.log("error", e);
    }
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
      </CardContainer>
      <br />
      <CardContainer>
        <Form form={form} layout='vertical'>
          <Col
            span={24}
            style={{
              padding: 8,
            }}
          >
            <DataCoDetail />
            <br />
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBg: "#EFF2F9",
                    fontFamily: "IBM Plex Sans Thai",
                    fontSize: 15,
                    footerBg: "#EFF2F9",
                  },
                },
              }}
            >
              <Form.Item name='products' noStyle>
                <Table
                  key={dataCoType?.coId}
                  rowKey='productId'
                  columns={columns}
                  dataSource={form.getFieldsValue(true).products || []}
                  pagination={false}
                  expandable={{
                    defaultExpandedRowKeys: [dataCoType?.products?.[0]?.productId],
                    expandedRowRender: (record, indexProd) => {
                      return (
                        <div>
                          <Form.Item name={["products", indexProd, "lines"]} noStyle>
                            <Table
                              size='small'
                              dataSource={record?.lines || []}
                              pagination={false}
                              columns={[
                                {
                                  title: "จำนวนสินค้า",
                                  width: "20%",
                                  render: (_, row, lineIndex) => {
                                    const value = form?.getFieldValue([
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                    ]);
                                    const keyName = [
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "quantity",
                                    ];
                                    return (
                                      <Form.Item
                                        name={keyName}
                                        rules={[
                                          { required: true, message: "กรุณากรอกจำนวนสินค้า" },
                                          {
                                            validator: (_, value) => {
                                              if (value) {
                                                const check = validateTotalQty(indexProd, record);
                                                if (check) {
                                                  return Promise.reject(
                                                    new Error("จำนวนสินค้าเกินกำหนด"),
                                                  );
                                                }
                                              }
                                              return Promise.resolve();
                                            },
                                          },
                                        ]}
                                      >
                                        <Input
                                          style={{ width: "100%", height: "40px" }}
                                          suffix={value?.saleUOMTH || "-"}
                                          autoComplete='off'
                                          placeholder='0'
                                          onKeyDown={onInputNumberKeyPress}
                                          onChange={(e) => {
                                            calTotalDiscountInProd(indexProd);
                                            const names = form
                                              .getFieldValue(["products", indexProd, "lines"])
                                              .map((_, i) => {
                                                const value = form.getFieldValue([
                                                  "products",
                                                  indexProd,
                                                  "lines",
                                                  i,
                                                  "quantity",
                                                ]);
                                                if (value > 0) {
                                                  return [
                                                    "products",
                                                    indexProd,
                                                    "lines",
                                                    i,
                                                    "quantity",
                                                  ];
                                                }
                                              });
                                            form.validateFields(names);
                                          }}
                                        />
                                      </Form.Item>
                                    );
                                  },
                                },
                                {
                                  title: "ส่วนลดหน่วย",
                                  width: "20%",
                                  render: (_, row, lineIndex) => {
                                    const keyNameDis = [
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "discountValue",
                                    ];
                                    const keyNameMode = [
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "discountMode",
                                    ];
                                    return (
                                      <Space.Compact style={{ width: "100%" }}>
                                        <Form.Item
                                          name={keyNameDis}
                                          rules={[
                                            { required: true, message: "กรุณากรอกส่วนลด" },
                                            {
                                              validator: (_, value) => {
                                                const mode = form.getFieldValue([
                                                  "products",
                                                  indexProd,
                                                  "lines",
                                                  lineIndex,
                                                  "discountMode",
                                                ]);
                                                if (mode.includes("PCT") && value > 100) {
                                                  return Promise.reject(
                                                    new Error("ส่วนลดเกิน 100%"),
                                                  );
                                                }
                                                return Promise.resolve();
                                              },
                                            },
                                          ]}
                                        >
                                          <Input
                                            style={{ width: "100%", height: "40px" }}
                                            autoComplete='off'
                                            placeholder='0'
                                            onKeyDown={onInputNumberKeyPress}
                                            onChange={(e) => {
                                              calTotalDiscountInProd(indexProd);
                                            }}
                                          />
                                        </Form.Item>
                                        <ConfigProvider
                                          theme={{
                                            components: {
                                              Select: {
                                                selectorBg: "#F3F6F9",
                                              },
                                            },
                                          }}
                                        >
                                          <Form.Item name={keyNameMode}>
                                            <Select
                                              allowClear={false}
                                              data={[
                                                {
                                                  label: "฿/หน่วย",
                                                  value: "BAHT_PER_UNIT",
                                                  key: "BAHT_PER_UNIT",
                                                },
                                                {
                                                  label: "%/หน่วย",
                                                  value: "PCT_PER_UNIT",
                                                  key: "PCT_PER_UNIT",
                                                },
                                              ]}
                                              onChange={(value) => {
                                                form.validateFields([keyNameDis]);
                                                calTotalDiscountInProd(indexProd);
                                                // const formData =
                                                //   form.getFieldsValue(true).products[indexProd];
                                                // const unitPrice =
                                                //   dataCoType.products[indexProd].unitPrice;
                                                // form.setFieldValue(
                                                //   ["products", indexProd, "calTotalDiscount"],
                                                //   formData.lines.reduce(
                                                //     (acc: number, line: any) => {
                                                //       if (line.discountMode === "PCT_PER_UNIT") {
                                                //         return (
                                                //           acc +
                                                //           (line.quantity || 0) *
                                                //             ((unitPrice * line.discountValue) / 100)
                                                //         );
                                                //       } else {
                                                //         return (
                                                //           acc +
                                                //           (line.quantity || 0) *
                                                //             (line.discountValue || 0)
                                                //         );
                                                //       }
                                                //     },
                                                //     0,
                                                //   ),
                                                // );
                                              }}
                                            />
                                          </Form.Item>
                                        </ConfigProvider>
                                      </Space.Compact>
                                    );
                                  },
                                },
                                {
                                  title: "รวมส่วนลด",
                                  width: "20%",
                                  render: (_, row, lineIndex) => {
                                    const mode = form.getFieldValue([
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "discountMode",
                                    ]);
                                    const keyNameQty = [
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "quantity",
                                    ];
                                    const keyNameDis = [
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "discountValue",
                                    ];
                                    const keyNameCalCo = [
                                      "products",
                                      indexProd,
                                      "lines",
                                      lineIndex,
                                      "calDiscount",
                                    ];
                                    return (
                                      <FlexCol>
                                        <Form.Item noStyle shouldUpdate>
                                          {({ getFieldValue }) => (
                                            <>
                                              <Text fontWeight={600}>
                                                {numberFormatter(getFieldValue(keyNameCalCo))}
                                              </Text>
                                              {getFieldValue(keyNameQty) && (
                                                <Text color='Text3' level={6}>
                                                  {mode.includes("PCT")
                                                    ? `(${numberFormatter(dataCoType.products[indexProd].unitPrice)} x ${numberFormatter(getFieldValue(keyNameQty))}) x ${numberFormatter(getFieldValue(keyNameDis))} %`
                                                    : `${numberFormatter(getFieldValue(keyNameDis))} x ${numberFormatter(getFieldValue(keyNameQty))}`}
                                                </Text>
                                              )}
                                            </>
                                          )}
                                        </Form.Item>
                                      </FlexCol>
                                    );
                                  },
                                },
                                {
                                  title: "",
                                  width: "5%",
                                  render: (_, row, lineIndex) => {
                                    const value = form.getFieldValue([
                                      "products",
                                      indexProd,
                                      "lines",
                                    ]);
                                    return (
                                      <>
                                        {value.length > 1 && (
                                          <DeleteOutlined
                                            style={{ color: color.error }}
                                            onClick={() =>
                                              onDeleteLine(record, lineIndex, indexProd)
                                            }
                                          />
                                        )}
                                      </>
                                    );
                                  },
                                },
                              ]}
                              footer={() => {
                                const value = form
                                  .getFieldValue(["products", indexProd, "lines"])
                                  .reduce(
                                    (acc, line) =>
                                      line.quantity > 0
                                        ? Number(acc) + Number(line.quantity)
                                        : Number(acc),
                                    0,
                                  );
                                return (
                                  <Row style={{ alignItems: "center" }} gutter={16}>
                                    <Col>
                                      <Text fontWeight={600}>รวม</Text>{" "}
                                      <Text
                                        style={{
                                          color: color[checkQtyTotal(value, indexProd).color],
                                        }}
                                      >
                                        {numberFormatter(value)}
                                      </Text>
                                      <Text color='Text3' level={6}>
                                        /{numberFormatter(record.orderQuantity)}{" "}
                                        {record?.saleUOMTH || ""}
                                      </Text>
                                    </Col>
                                    <Col>
                                      <Tag
                                        color={checkQtyTotal(value, indexProd).color}
                                        style={{ border: "none", borderRadius: 8 }}
                                      >
                                        <Text
                                          style={{
                                            color: color[checkQtyTotal(value, indexProd).color],
                                          }}
                                          level={6}
                                          fontWeight={400}
                                        >
                                          {checkQtyTotal(value, indexProd).text}{" "}
                                          {(checkQtyTotal(value, indexProd).value &&
                                            `${numberFormatter(checkQtyTotal(value, indexProd).value || 0)} ${record?.saleUOMTH || ""}`) ||
                                            ""}
                                        </Text>
                                      </Tag>
                                    </Col>
                                  </Row>
                                );
                              }}
                            />
                          </Form.Item>
                          <br />
                          <Button
                            typeButton='border-dashed-primary'
                            title='เพิ่มรายการ'
                            onClick={() => addNewLine(record)}
                          />
                        </div>
                      );
                    },
                    expandIcon: ({ expanded, onExpand, record }) => {
                      return expanded ? (
                        <UpOutlined onClick={(event) => onExpand(record, event)} />
                      ) : (
                        <DownOutlined onClick={(event) => onExpand(record, event)} />
                      );
                    },
                  }}
                  footer={() => {
                    const totalUse = form
                      .getFieldsValue(true)
                      ?.products?.reduce((acc: number, product: any) => {
                        return Number(acc) + (Number(product.calTotalDiscount) || 0);
                      }, 0);
                    return (
                      <Row justify='start' gutter={8}>
                        <Col span={16}>
                          <Text fontWeight={600}>รวมส่วนลดทั้งหมด</Text>
                        </Col>
                        <Col span={8} style={{ textAlign: "right" }}>
                          <Col>
                            <Text fontWeight={600}>{numberFormatter(totalUse)}</Text>
                            <Text color='Text3' level={6}>
                              /{numberFormatter(dataCoType?.usedThisOrder || 0)}
                            </Text>{" "}
                            <Tag
                              color={checkQtyGrandTotal().color}
                              style={{ border: "none", borderRadius: 8 }}
                            >
                              <Text
                                style={{
                                  color: color[checkQtyGrandTotal().color],
                                }}
                                level={6}
                                fontWeight={400}
                              >
                                {checkQtyGrandTotal().text}{" "}
                                {(checkQtyGrandTotal().value &&
                                  numberFormatter(checkQtyGrandTotal().value || 0)) ||
                                  ""}
                              </Text>
                            </Tag>
                          </Col>
                        </Col>
                      </Row>
                    );
                  }}
                />
              </Form.Item>
            </ConfigProvider>
          </Col>
        </Form>
        <br />
        <Row justify='space-between' gutter={12}>
          <Col span={3}>
            <Button
              typeButton='primary-light'
              title='ย้อนกลับ'
              onClick={() => window.history.back()}
            />
          </Col>
          <Col span={3}>
            <Button
              typeButton='primary'
              title='บันทึก'
              onClick={() => {
                if (!isValidate) {
                  setModalConfirm(true);
                }
              }}
            />
          </Col>
        </Row>
      </CardContainer>
      {modalConfirm && (
        <Modal
          open={modalConfirm}
          onCancel={() => setModalConfirm(false)}
          onOk={onSubmit}
          cancelButtonProps={{ style: { display: "none" } }}
          centered
          maskClosable={false}
        >
          <Col style={{ marginBottom: 16 }}>
            <Text level={4} fontWeight={600}>
              ระบุหมายเหตุเพิ่มเติม
            </Text>
          </Col>
          <Form form={form} layout='vertical'>
            <Form.Item
              label='หมายเหตุการแก้ไข'
              name='remark'
              rules={[
                {
                  required: userProfile.company === "ICPL",
                  message: "กรุณาระบุหมายเหตุการแก้ไข",
                },
              ]}
            >
              <Input
                placeholder='ระบุหมายเหตุการแก้ไข'
                style={{ height: "40px", width: "100%" }}
                autoComplete='off'
              />
            </Form.Item>
          </Form>
        </Modal>
      )}
      {modalCheckDiscount && (
        <Modal
          open={modalCheckDiscount}
          onCancel={() => setModalCheckDiscount(false)}
          onOk={() => setModalCheckDiscount(false)}
          cancelButtonProps={{ style: { display: "none" } }}
          centered
          maskClosable={false}
          okText='เข้าใจแล้ว'
          width={570}
        >
          <Text level={2} fontWeight={600}>
            ใช้ส่วนลดได้ไม่เต็มจำนวน
          </Text>
          <br />
          <Text color='Text3'>
            เนื่องจากยอดส่วนลดคงเหลือไม่เพียงพอ ระบบจึงใช้ส่วนลดให้คุณได้ตามยอดที่เหลืออยู่ เท่านั้น
          </Text>
        </Modal>
      )}
    </>
  );
};
